export default "__VITE_ASSET__BSyPa8Ut__"